import { Component, inject, OnInit } from '@angular/core';
import { AppsFlyerService } from '@core';
import { StartupStepService } from './startup/startup-steps.service';

@Component({
  selector: 'app-component',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  private readonly startupStepService: StartupStepService = inject(StartupStepService);
  private readonly appsFlyerService: AppsFlyerService = inject(AppsFlyerService);

  ngOnInit(): void {
    this.startupStepService.init();

    // this.appsFlyerService.logEvent('af_app_opened', {
    //   timestamp: Date.now()
    // });
  }
}
